/**
 * Apply a  reset based on tag name.
 */
export function cssReset(defaultTagName) {
  return (props) => {
    const tagName = props.as || defaultTagName
    const sharedResetStyles = {
      boxSizing: 'border-box'
    }
    const resetStyles = {
      ...sharedResetStyles,
      ...RESET_TAG_MAP[tagName]
    }

    return resetStyles
  }
}

//
// PRIVATE HELPERS
//

const getBaseInputResetStyles = () => ({
  ...getFocusableResetStyles(),
  appearance: 'none',
  backgroundColor: 'transparent',
  border: 'none',
  borderRadius: 0,
  color: 'inherit',
  fontFamily: 'inherit',
  fontSize: 'inherit',
  fontWeight: 'normal',
  margin: 0,
  padding: 0
})

const getHeadingResetStyles = () => ({
  margin: 0,
  fontSize: 'inherit',
  fontWeight: 'normal'
})

const getFocusableResetStyles = () => ({
  WebkitTapHighlightColor: 'rgba(0, 0, 0, 0)',
  '&:focus': { outline: 'none' }
})

const RESET_TAG_MAP = {
  a: { ...getFocusableResetStyles(), color: 'inherit', textDecoration: 'none' },
  blockquote: { margin: 0 },
  button: getBaseInputResetStyles(),
  code: { fontFamily: 'inherit' },
  div: {
    alignItems: 'stretch',
    border: '0 solid black',
    boxSizing: 'border-box',
    display: 'flex',
    flexBasis: 'auto',
    flexShrink: 0,
    flexDirection: 'column',
    margin: 0,
    minHeight: 0,
    minWidth: 0,
    overflow: 'auto',
    padding: 0,
    position: 'relative',
    zIndex: 'inherit'
  },
  h1: getHeadingResetStyles(),
  h2: getHeadingResetStyles(),
  h3: getHeadingResetStyles(),
  h4: getHeadingResetStyles(),
  h5: getHeadingResetStyles(),
  h6: getHeadingResetStyles(),
  header: {},
  hr: {
    margin: 0,
    border: 'none'
  },
  img: {},
  input: {
    ...getBaseInputResetStyles(),
    verticalAlign: 'middle',
    width: '100%',
    '&::-webkit-slider-runnable-track': { backgroundColor: 'transparent' },
    '&::-moz-range-track': { backgroundColor: 'transparent' },
    '::-moz-focus-outer': { border: 0 },
    '&::-webkit-slider-thumb': { appearance: 'none', marginTop: 0 },
    '&::-moz-range-thumb': { appearance: 'none', marginTop: 0 }
  },
  p: { margin: 0 },
  select: {
    ...getBaseInputResetStyles(),
    backgroundColor: 'transparent',
    borderRadius: 0
  },
  span: {},
  svg: {
    display: 'block',
    verticalAlign: 'middle'
  },
  table: {},
  thead: {},
  tfoot: {},
  tbody: {},
  tr: {},
  th: { fontWeight: 'normal', padding: 0, textAlign: 'unset' },
  td: { padding: 0 },
  textarea: getBaseInputResetStyles()
}
